<template>
  <div style="width:100%">
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-list two-line>
            <template v-for="(item, index) in items">
              <v-subheader
                v-if="item.header"
                :key="index"
              >
                {{ item.header }}
              </v-subheader>

              <v-divider
                v-else-if="item.divider"
                :key="index"
                :inset="item.inset"
              ></v-divider>

              <v-list-tile
                v-else
                :key="index"
                avatar
              >
                <v-list-tile-avatar>
                  <i class="material-icons" style="font-size:35px">{{item.avatar}}</i>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="item.title" style="white-space:normal; height:fit-content;"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'user-details',
  props: {
    user: Object,
    current_user: Boolean
  },
  data () {
    return {
      items: [
        { header: moment(this.user.createdAt).format('MMMM Do YYYY') || 'User Information' },
        {
          avatar: 'account_circle',
          title: this.user.name || '* No Name Entered *',
          subtitle: 'category: Name'
        },
        { divider: true, inset: true },
        {
          avatar: 'email',
          title: this.user.email || '* No Email Entered *',
          subtitle: 'category: Email'
        },
        { divider: true, inset: true },
        {
          avatar: 'phone',
          title: this.user.phone || '* No Phone Entered *',
          subtitle: 'category: Phone'
        },
        { divider: true, inset: true },
        {
          avatar: 'code',
          title: this.user.code || '* No Code Entered *',
          subtitle: 'category: Code'
        }
      ],
      icons: {
        age: 'access_time',
        gender: 'accessibility_new',
        locations: 'location_on',
        type: 'business',
        travel: 'card_travel',
        accommodation: 'home',
        event: 'event'
      }
    }
  },
  methods: {
    pretty_list(list) {
      let list_string = ''
      list.forEach((item) => {
        list_string += item + ', ';
      })
      return list_string
    }
  },
  mounted() {
    if (this.current_user) {
      this.$store.dispatch('getUserData', {data_type: 'general'})
        .then(() => {
          let user_general = this.$store.getters.user.general
          for (let data_cat in user_general) {
            let data_value;

            if (typeof user_general[data_cat] == 'object')
              data_value = this.pretty_list(user_general[data_cat])
            else
              data_value = user_general[data_cat]

            this.items.push({ divider: true, inset: true })
            this.items.push({
              avatar: this.icons[data_cat],
              title: data_value,
              subtitle: 'category: ' + data_cat.charAt(0).toUpperCase() + data_cat.slice(1)
            })
          }
        })
        .catch(error => {
          this.showError(error)
        })
    }
  }
}
</script>

<style scoped>
</style>
